import { Row, Col, Button } from 'antd';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { setEnvPrefix } = ssCommonUtils;

export default class extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { registrationPath } = this.props;
        return (
            <div>{
                registrationPath.map(({ title, path }, i) => (
                    <Row 
                        key={`afsp-login-registration-option-${i}`} 
                        style={{ 
                            marginBottom: i !== registrationPath.length - 1 ? '4px' : '-8px' ,
                            marginTop: i !== 0 ? 'initial' : '-8px'
                        }}
                    >
                        <Col span={24}>
                            <Button
                                type='primary'
                                size='small'
                                style={{ width: '100%' }}
                                onClick={() => window.location.href = setEnvPrefix(path)}
                            >
                                {title}
                            </Button>
                        </Col>
                    </Row>
                ))
            }</div>
        )
    }
}